import { useLandingAccess } from 'legacy/lut/components/shared/headerLut/hooks/useLandingAccess'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { COVERAGE_REPORT_MIN_FYEAR } from 'partner360/features/partnersCoverage'

import { selectCockpitUserAccess, selectEffectiveCockpitFYear } from '../../../model/selectors'
import type { TManagerPlanningCockpitSection } from '../ManagerPlanningCockpitSwitcher'

const GEO_LEAD_ROLE_ID = 'P360GeoLead'
const P360_TESTER = 'P360Tester'

export const useManagerPlanningCockpitSections = (): TManagerPlanningCockpitSection[] => {
  const { isPBMLandingAllowed, isManagerLandingAllowed } = useLandingAccess()
  const { role } = useSelector(selectCockpitUserAccess)
  const fYear = useSelector(selectEffectiveCockpitFYear)
  const isP360Tester = role === P360_TESTER
  const isGeoLead = role === GEO_LEAD_ROLE_ID

  return useMemo<TManagerPlanningCockpitSection[]>(
    () => [
      'cockpit',
      ...(isP360Tester || isManagerLandingAllowed ? (['topPartners'] as const) : []),
      ...(isP360Tester || isPBMLandingAllowed ? (['myPartners'] as const) : []),
      ...(isP360Tester || isGeoLead
        ? (['businessPriorities', 'marketYoyTargets', 'strategicInitiatives'] as const)
        : []),
      ...(isP360Tester && fYear && fYear >= COVERAGE_REPORT_MIN_FYEAR
        ? (['coverageReport'] as const)
        : []),
    ],
    [fYear, isGeoLead, isManagerLandingAllowed, isP360Tester, isPBMLandingAllowed]
  )
}
